import { toast } from 'sonner';

// Shared clipboard helper.
//
// navigator.clipboard.writeText rejects in insecure contexts (non-HTTPS) and
// on permission denial. Callers were firing a success toast unconditionally,
// so a failed copy still claimed success — especially bad for one-time secret
// reveals (API keys). This awaits the write and toasts the real outcome.

/**
 * Copy text to the clipboard, showing a success/error toast.
 *
 * @param {string} text
 * @param {string} [successMessage]
 * @returns {Promise<boolean>} true if the copy succeeded
 */
export async function copyToClipboard(text, successMessage = 'Copied to clipboard') {
  try {
    if (!navigator.clipboard) throw new Error('Clipboard API unavailable');
    await navigator.clipboard.writeText(text);
    toast.success(successMessage);
    return true;
  } catch (err) {
    toast.error('Copy failed — please copy manually');
    return false;
  }
}

export default copyToClipboard;
